import React, { Component } from 'react';
import { Container, Grid } from '@mui/material';
import WithRouter from '../Layout/Router/WithRouter';
import PageNavigationCard from '../common/PageNavigationCard';
import PortalPageHeader from '../common/PortalPageHeader';
import { PageDetails } from './config';

class AdminPanel extends Component {
  render() {
    const pageId = 'adminPanel';
    const pageDetails = PageDetails[pageId];
    const adminPages = Object.values(PageDetails).filter((page) => page.id !== pageId);

    return (
      <Container id={`${pageId}__container_pageWrapper`} className="myOdu__container secondaryPage">
        <PortalPageHeader
          title={pageDetails.title}
          id={pageId}
          breadcrumbs={pageDetails.breadcrumbs}
        />
        <Grid container spacing={2} alignItems={'stretch'}>
          {adminPages.map((item) => (
            <Grid item id={`adminPanel__${item.page}`} md={6} sm={12} xs={12} key={item.id}>
              <PageNavigationCard
                header={'h3'}
                cardClass="admin"
                id={pageId}
                url={pageDetails.url}
                subPage={item}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    );
  }
}

export default WithRouter(AdminPanel);
